import { useForm } from 'react-hook-form';

import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import { Typography } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import CommonPatientInfo from '../../components/CommonPatientInfo';

import { SurveyDialogProps, TK_CPATDefaultValues } from '../../type';
import { updateK_CPAT } from 'apis/survey';
import PainLocation from './PainLocation';
import PainCharacter from './PainCharacter';
import NRSPoint from './NRSPoint';
import PainSymptoms from './PainSymptoms';
import PainEffect from './PainEffect';

const K_CPAT = (props: SurveyDialogProps<TK_CPATDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    patientInfo,
    nurseName,
    user_id,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();
  const { handleSubmit, watch, getValues, setValue, register } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TK_CPATDefaultValues) => {
    const {
      no_1,

      no_2_a_1,
      no_2_a_2,
      no_2_a_3,
      no_2_a_4,
      no_2_a_5,
      no_2_a_6,

      no_2_b_1,
      no_2_b_2,
      no_2_b_3,
      no_2_b_4,
      no_2_b_5,
      no_2_b_6,

      no_2_c_1,
      no_2_c_2,
      no_2_c_3,
      no_2_c_4,
      no_2_c_5,

      no2_d_input,
      no2_d,

      no3,

      no4,

      no5_1,
      no5_2,
      no5_3,
      no5_4,
      no5_5,
      no5_6,
      no5_7,
      no5_8,
    } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      contents: {
        no_1,

        no_2_a_1,
        no_2_a_2,
        no_2_a_3,
        no_2_a_4,
        no_2_a_5,
        no_2_a_6,

        no_2_b_1,
        no_2_b_2,
        no_2_b_3,
        no_2_b_4,
        no_2_b_5,
        no_2_b_6,

        no_2_c_1,
        no_2_c_2,
        no_2_c_3,
        no_2_c_4,
        no_2_c_5,

        no2_d_input,
        no2_d,

        no3,

        no4: JSON.stringify(no4),

        no5_1,
        no5_2,
        no5_3,
        no5_4,
        no5_5,
        no5_6,
        no5_7,
        no5_8,
      },
    };
    updateK_CPAT(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => onFail('저장에 실패하였습니다', e));
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        표준형 성인 암성 통증 평가지 (K-CPAT)
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <PainLocation {...formProps} />
      <PainCharacter {...formProps} />
      <NRSPoint {...formProps} />
      <PainSymptoms {...formProps} />
      <PainEffect {...formProps} />
    </MuiDialog.SurveyForm>
  );
};

export default K_CPAT;
